'use strict';

var React = require('react');

var SvgWearableMajor = function SvgWearableMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 8.75a.75.75 0 0 0-1.5 0v1.25c0 .199.079.39.22.53l1.25 1.25a.75.75 0 1 0 1.06-1.06l-1.03-1.03v-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 3a1.75 1.75 0 0 0-1.75 1.75v.933a3.75 3.75 0 0 0-2 3.317v2a3.75 3.75 0 0 0 2 3.318v.932c0 .966.784 1.75 1.75 1.75h2a1.75 1.75 0 0 0 1.75-1.75v-.932a3.75 3.75 0 0 0 2-3.318v-2a3.75 3.75 0 0 0-2-3.317v-.933a1.75 1.75 0 0 0-1.75-1.75h-2Zm0 2.25c-.084 0-.167.003-.25.008v-.508a.25.25 0 0 1 .25-.25h2a.25.25 0 0 1 .25.25v.508a3.805 3.805 0 0 0-.25-.008h-2Zm-.25 10v-.508c.083.005.166.008.25.008h2c.084 0 .167-.003.25-.008v.508a.25.25 0 0 1-.25.25h-2a.25.25 0 0 1-.25-.25Zm.25-8.5a2.25 2.25 0 0 0-2.25 2.25v2a2.25 2.25 0 0 0 2.25 2.25h2a2.25 2.25 0 0 0 2.25-2.25v-2a2.25 2.25 0 0 0-2.25-2.25h-2Z"
  }));
};
SvgWearableMajor.displayName = "WearableMajor";

exports.SvgWearableMajor = SvgWearableMajor;
